
import { computed, defineComponent, onBeforeMount, ref, watch } from "vue";
import { useRoute } from "vue-router";
import router from "@/router";

import { doc, onSnapshot, updateDoc, arrayRemove } from "firebase/firestore";
import { db } from "@/firebase/index";

// import Game from "@/types/Game";
import Player from "@/types/Player";

export default defineComponent({
  setup() {
    const route = useRoute();
    const gameData = ref<any>(null);
    const playerId = ref("");

    const isOwner = (pid: string) => {
      return gameData.value.createdBy == pid;
    };

    const assignRoles = async () => {
      const playersAmount = gameData.value.players.length;
      let rolesDistribution = "";
      switch (playersAmount) {
        case 7:
          rolesDistribution = "mdrtr_wrwlf_dr_drnk_vllgr_vllgr_vllgr";
          break;
        case 8:
          rolesDistribution = "mdrtr_wrwlf_wrwlf_dr_seer_drnk_vllgr_vllgr";
          break;
        case 9:
          rolesDistribution =
            "mdrtr_wrwlf_wrwlf_dr_seer_drnk_vllgr_vllgr_vllgr";
          break;
        case 10:
          rolesDistribution =
            "mdrtr_wrwlf_wrwlf_dr_seer_drnk_vllgr_vllgr_vllgr_vllgr";
          break;
      }
      let allRoles = rolesDistribution.split("_");
      gameData.value.players.forEach((player: Player) => {
        let randomIndex = Math.floor(Math.random() * allRoles.length);
        player.role = allRoles[randomIndex];
        allRoles.splice(randomIndex, 1);
      });
      const gameRef = doc(db, "games", `${route.params.gameId}`);
      console.log(gameData.value.players);
      await updateDoc(gameRef, {
        players: gameData.value.players,
        status: "inGame",
      });
    };

    const removePlayer = (player: Player) => {
      const gameId = `${route.params.gameId}`;
      const gameRef = doc(db, "games", gameId);
      updateDoc(gameRef, {
        players: arrayRemove(player),
      });
      console.log(player);
    };

    const watchStatus = computed(() => {
      return gameData.value;
    });

    watch(watchStatus, (newStatus, oldStatus) => {
      try {
        if (oldStatus.status == "lobby" && newStatus.status == "inGame") {
          alert("starting game!!!!");
          router.push(`/game/${route.params.gameId}`);
        }
      } catch (err) {
        console.log("err");
      }
    });

    onBeforeMount(() => {
      const gameId = `${route.params.gameId}`;
      playerId.value = `${localStorage.getItem("wrwlfPid")}`;
      onSnapshot(doc(db, "games", gameId), (doc) => {
        gameData.value = doc.data();
      });
    });
    return {
      gameData,
      isOwner,
      playerId,
      assignRoles,
      watchStatus,
      removePlayer,
    };
  },
});
